// extracted by mini-css-extract-plugin
module.exports = {"input":"BuildTeamDialog_input__2wJ-Z","accordion":"BuildTeamDialog_accordion__1vBb-"};